import React, { useState } from "react";
import JobTypeListing from "../listing";
import FixedFilters from "./filters";
import { TypeStatsSection } from "../components/type-stats-section";

export default function FixedJobs() {

  const [filters,setFilters]=useState({})
  

  return (
    <JobTypeListing 
      type="fixed" 
      title="Fixed Jobs" 
      filters={FixedFilters}
     onFiltersChange={setFilters}
      renderContent={() => (
        <TypeStatsSection jobType="fixed" filters={filters} />
      )}
    />
  );
}
